import { createReducer } from '@reduxjs/toolkit';
import AvailabilityReducer from './availability_reducer';
import BookingReducer from './booking_reducer';
import CheckoutReducer from './checkout_reducer';
import ResourcesReducer from './resources_reducer';
import ServicesReducer from './services_reducer';
import UIReducer from './ui';
import VehicleLinkReducer from './vehicle_link_reducer';

const { redux_initial_state: initialState } = window.ecom;
const reducers = {
  booking: BookingReducer,
  types: createReducer(initialState.types || {}, {}),
  resources: ResourcesReducer,
  availability: AvailabilityReducer,
  vehicleLink: VehicleLinkReducer,
  product_page_id: createReducer(initialState.product_page_id, {}),
  checkout: CheckoutReducer,
  countries: createReducer(initialState.countries || {}, {}),
  regions: createReducer(initialState.regions || {}, {}),
  locations: createReducer(initialState.locations || {}, {}),
  ui: UIReducer,
  services: ServicesReducer,
  sealink: createReducer(initialState.sealink || {}, {}),
  routes: createReducer(initialState.routes || {}, {}),
};

export default reducers;
